/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_801Inputs */

const cs_ares_legal_form_801 = /** @type {(inputs: Ares_Legal_Form_801Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Občanské sdružení`)
};

const en_ares_legal_form_801 = /** @type {(inputs: Ares_Legal_Form_801Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Civic association`)
};

/**
* | output |
* | --- |
* | "Civic association" |
*
* @param {Ares_Legal_Form_801Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_801 = /** @type {((inputs?: Ares_Legal_Form_801Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_801Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_801(inputs)
	return cs_ares_legal_form_801(inputs)
});